import { render, staticRenderFns } from "./IconBoxArchive.vue?vue&type=template&id=1c7cf676&functional=true&"
import script from "./IconBoxArchive.vue?vue&type=script&lang=js&"
export * from "./IconBoxArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports